module.exports = __webpack_public_path__ + "img/bg-page-02.f78bba63.png";